import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Switch, Route, Redirect, NavLink } from 'react-router-dom';
import Dashboard from './dashboard';
import Cron from './cron';
import Logs from './logs';
import Backups from './backups';
import Stocks from './stocks';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

interface SubNavItem {
	key: string;
	path: string;
	label: string;
	icon: string;
}

const SUB_NAV: SubNavItem[] = [
	{ key: 'dashboard', path: '/admin/system/dashboard', label: 'Dashboard', icon: '◧' },
	{ key: 'cron',      path: '/admin/system/cron',      label: 'Cron',      icon: '⏱' },
	{ key: 'logs',      path: '/admin/system/logs',      label: 'Logs',      icon: '≡' },
	{ key: 'backups',   path: '/admin/system/backups',   label: 'Backups',   icon: '⤓' },
	{ key: 'stocks',    path: '/admin/system/stocks',    label: 'Activos digitales', icon: '$' },
];

class SystemLayout extends React.Component<Props> {

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Sistema',
				onBack: null
			}
		});
	}

	render() {
		return (
			<div id="admin-system">
				<aside className="system-sidebar">
					<p className="system-sidebar-title">Sistema</p>
					<nav className="system-sidebar-nav">
						{
							SUB_NAV.map((item) => (
								<NavLink
									key={ item.key }
									to={ item.path }
									className="system-nav-item"
									activeClassName="active">
									<span className="system-nav-icon" aria-hidden="true">{ item.icon }</span>
									<span className="system-nav-label">{ item.label }</span>
								</NavLink>
							))
						}
					</nav>
				</aside>

				<section className="system-content">
					<Switch>
						<Route exact path="/admin/system/dashboard" component={ Dashboard } />
						<Route exact path="/admin/system/cron" component={ Cron } />
						<Route exact path="/admin/system/logs" component={ Logs } />
						<Route exact path="/admin/system/backups" component={ Backups } />
						<Route exact path="/admin/system/stocks" component={ Stocks } />
						<Route exact path="/admin/system">
							<Redirect to="/admin/system/dashboard" />
						</Route>
					</Switch>
				</section>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(SystemLayout);
